import React from 'react';
import { Toolbar, Typography, IconButton, Tooltip, Icon } from '@mui/material';
import { withStyles } from '@mui/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const styles = {
  root: {
    paddingLeft: 16,
    paddingRight: 8,
  },
  highlight: {
    backgroundColor: '#F6BF00D9', // Hardcoded light yellow with 85% opacity
    color: '#004a6b', // Hardcoded dark blue text
  },
  title: {
    flex: '1 1 100%',
  },
};

export const AddTableToolbar = (props) => {
  const { 
    classes,
    numSelected, 
    title, 
    selectedMssg, 
    onAddItem, 
    onDeleteItem, 
    addIcon, 
    tooltip 
  } = props;

  return (
    <Toolbar
      className={`${classes.root} ${numSelected > 0 ? classes.highlight : ''}`}
    >
      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
          {selectedMssg}
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
          {title}
          {tooltip && (
            <Tooltip
              placement="top"
              title={
                <Typography variant="body2" style={{ whiteSpace: 'pre-line' }}>
                  {tooltip}
                </Typography>
              }
            >
              <Icon fontSize="inherit">help_outline</Icon>
            </Tooltip>
          )}
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Eliminar">
          <IconButton onClick={onDeleteItem}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Añadir">
          <IconButton onClick={onAddItem}>{addIcon || <AddIcon />}</IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

export default withStyles(styles)(AddTableToolbar);
